/**
 * ******************
 * COUNT ITEM IN CART
 * ******************
 */

/**
 * Count the products in the cart (product x quantity)
 */
function countItemsInCart() {
    $.get( url_cart_countItems, {
        time: Date.now()
    }, function( count ) {
        if(count > 0) {
            $(".js-cart-counter").text(count).show();
        }
        else {
            $(".js-cart-counter").text(count).hide();
        }

        if (typeof registraionConfirmed !== 'undefined') {
            if(count > 0) {
                $('#goToHome').hide();
                $('#goToCart').show();
            }
            else {
                $('#goToCart').hide();
                $('#goToHome').show();
            }
        }
    });
}

$(function () {
    countItemsInCart();
});